var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 29.6667V32C34 35.3137 31.3137 38 28 38H10C6.68629 38 4 35.3137 4 32V16C4 12.6863 6.68629 10 10 10H28C31.3137 10 34 12.6863 34 16V18.3334L39.0795 14.1005C41.0334 12.4722 44 13.8616 44 16.4052V31.5949C44 34.1384 41.0334 35.5279 39.0794 33.8996L34 29.6667ZM10 12H28C30.2091 12 32 13.7909 32 16V32C32 34.2091 30.2091 36 28 36H10C7.79086 36 6 34.2091 6 32V16C6 13.7909 7.79086 12 10 12ZM34 27.0633L40.3598 32.3631C41.0111 32.9059 42 32.4427 42 31.5949V16.4052C42 15.5573 41.0111 15.0942 40.3598 15.6369L34 20.9368V27.0633Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.5c190aa0adf975609f41412c5b63d474.svg";
export { ForwardRef as ReactComponent };